import { render, staticRenderFns } from "./SceneMetaTab.vue?vue&type=template&id=b99a4f04"
import script from "./SceneMetaTab.vue?vue&type=script&lang=js"
export * from "./SceneMetaTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports